//# sourceMappingURL=organizations.mjs.map
/// <reference types="./organizations.d.mts" />
import * as $remote from "../../../data_types/data/remote.mjs";
import * as $dict from "../../../gleam_stdlib/gleam/dict.mjs";
import * as $pair from "../../../gleam_stdlib/gleam/pair.mjs";
import * as $effect from "../../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $store from "../../data/store.mjs";

export function update(store, msg) {
  if (msg instanceof $msg.ApiReturnedOrganizations) {
    let total = msg.total;
    let organizations = msg.organizations;
    let _pipe = store;
    let _pipe$1 = $store.set_organizations(
      _pipe,
      new $remote.Loaded([total, organizations]),
    );
    let _pipe$2 = $store.set_default_organization(_pipe$1);
    return $pair.new$(_pipe$2, $effect.none());
  } else if (msg instanceof $msg.ApiStartedLoadingOrganizations) {
    let _pipe = store;
    let _pipe$1 = $store.set_organizations(_pipe, new $remote.Loading());
    return $pair.new$(_pipe$1, $effect.none());
  } else if (msg instanceof $msg.ApiErroredOrganizations) {
    let content = msg.content;
    let _pipe = store;
    let _pipe$1 = $store.set_organizations(_pipe, new $remote.Errored(content));
    return $pair.new$(_pipe$1, $effect.none());
  } else if (msg instanceof $msg.ApiReturnedOrganizationsUsers) {
    let org_id = msg.org_id;
    let users = msg.users;
    let _pipe = store.organizations_users;
    let _pipe$1 = $dict.insert(_pipe, org_id, new $remote.Loaded(users));
    let _pipe$2 = ((_capture) => {
      return $store.set_organizations_users(store, _capture);
    })(_pipe$1);
    return $pair.new$(_pipe$2, $effect.none());
  } else if (msg instanceof $msg.ApiStartedLoadingOrganizationsUsers) {
    let org_id = msg.org_id;
    let _pipe = store.organizations_users;
    let _pipe$1 = $dict.insert(_pipe, org_id, new $remote.Loading());
    let _pipe$2 = ((_capture) => {
      return $store.set_organizations_users(store, _capture);
    })(_pipe$1);
    return $pair.new$(_pipe$2, $effect.none());
  } else if (msg instanceof $msg.ApiErroredOrganizationsUsers) {
    let org_id = msg.org_id;
    let content = msg.content;
    let _pipe = store.organizations_users;
    let _pipe$1 = $dict.insert(_pipe, org_id, new $remote.Errored(content));
    let _pipe$2 = ((_capture) => {
      return $store.set_organizations_users(store, _capture);
    })(_pipe$1);
    return $pair.new$(_pipe$2, $effect.none());
  } else if (msg instanceof $msg.ApiReturnedOrganizationsTags) {
    let org_id = msg.org_id;
    let tags = msg.tags;
    let _pipe = store.organizations_tags;
    let _pipe$1 = $dict.insert(_pipe, org_id, new $remote.Loaded(tags));
    let _pipe$2 = ((_capture) => {
      return $store.set_organizations_tags(store, _capture);
    })(_pipe$1);
    return $pair.new$(_pipe$2, $effect.none());
  } else if (msg instanceof $msg.ApiStartedLoadingOrganizationsTags) {
    let org_id = msg.org_id;
    let _pipe = store.organizations_tags;
    let _pipe$1 = $dict.insert(_pipe, org_id, new $remote.Loading());
    let _pipe$2 = ((_capture) => {
      return $store.set_organizations_tags(store, _capture);
    })(_pipe$1);
    return $pair.new$(_pipe$2, $effect.none());
  } else if (msg instanceof $msg.ApiErroredOrganizationsTags) {
    let org_id = msg.org_id;
    let content = msg.content;
    let _pipe = store.organizations_tags;
    let _pipe$1 = $dict.insert(_pipe, org_id, new $remote.Errored(content));
    let _pipe$2 = ((_capture) => {
      return $store.set_organizations_tags(store, _capture);
    })(_pipe$1);
    return $pair.new$(_pipe$2, $effect.none());
  } else if (msg instanceof $msg.ApiReturnedOrganizationsConnections) {
    let org_id = msg.org_id;
    let connections = msg.connections;
    let _pipe = store.organizations_enabled_connections;
    let _pipe$1 = $dict.insert(_pipe, org_id, new $remote.Loaded(connections));
    let _pipe$2 = ((_capture) => {
      return $store.set_organizations_enabled_connections(store, _capture);
    })(_pipe$1);
    return $pair.new$(_pipe$2, $effect.none());
  } else if (msg instanceof $msg.ApiStartedLoadingOrganizationsConnections) {
    let org_id = msg.org_id;
    let _pipe = store.organizations_enabled_connections;
    let _pipe$1 = $dict.insert(_pipe, org_id, new $remote.Loading());
    let _pipe$2 = ((_capture) => {
      return $store.set_organizations_enabled_connections(store, _capture);
    })(_pipe$1);
    return $pair.new$(_pipe$2, $effect.none());
  } else if (msg instanceof $msg.ApiErroredOrganizationsConnections) {
    let org_id = msg.org_id;
    let content = msg.content;
    let _pipe = store.organizations_enabled_connections;
    let _pipe$1 = $dict.insert(_pipe, org_id, new $remote.Errored(content));
    let _pipe$2 = ((_capture) => {
      return $store.set_organizations_enabled_connections(store, _capture);
    })(_pipe$1);
    return $pair.new$(_pipe$2, $effect.none());
  } else if (msg instanceof $msg.ApiStartedLoadingOrganizationsInvitations) {
    let org_id = msg.org_id;
    let _pipe = store.organizations_invitations;
    let _pipe$1 = $dict.insert(_pipe, org_id, new $remote.Loading());
    let _pipe$2 = ((_capture) => {
      return $store.set_organizations_invitations(store, _capture);
    })(_pipe$1);
    return $pair.new$(_pipe$2, $effect.none());
  } else if (msg instanceof $msg.ApiErroredOrganizationsInvitations) {
    let org_id = msg.org_id;
    let content = msg.content;
    let _pipe = store.organizations_invitations;
    let _pipe$1 = $dict.insert(_pipe, org_id, new $remote.Errored(content));
    let _pipe$2 = ((_capture) => {
      return $store.set_organizations_invitations(store, _capture);
    })(_pipe$1);
    return $pair.new$(_pipe$2, $effect.none());
  } else if (msg instanceof $msg.ApiReturnedOrganizationsInvitations) {
    let org_id = msg.org_id;
    let invitations = msg.invitations;
    let _pipe = store.organizations_invitations;
    let _pipe$1 = $dict.insert(_pipe, org_id, new $remote.Loaded(invitations));
    let _pipe$2 = ((_capture) => {
      return $store.set_organizations_invitations(store, _capture);
    })(_pipe$1);
    return $pair.new$(_pipe$2, $effect.none());
  } else {
    let connected_sockets = msg[0];
    return [
      new $store.Store(
        store.connections,
        store.organizations,
        store.organizations_tags,
        store.organizations_users,
        store.organizations_invitations,
        store.organizations_enabled_connections,
        store.organizations_ai_config,
        store.organizations_qm_rows,
        connected_sockets,
        store.projects,
        store.proposals,
        store.page_index,
        store.proposal_elements,
        store.answers,
        store.translations,
        store.label_translations,
        store.label_translations_search,
        store.label_translations_language_filter,
        store.label_translations_sort,
        store.llm_rate_limits,
        store.organizations_activity,
        store.llm_usage,
        store.llm_usage_by_org,
        store.client,
        store.organization,
        store.route,
        store.user,
        store.user_id,
        store.content_library,
        store.ingestion_control_sources,
        store.ingestion_control_sources_visibility,
        store.loading,
        store.users,
        store.roles,
        store.maintenance_mode,
        store.data_sources,
        store.analytics,
        store.metrics_groups,
        store.dashboard_options,
        store.project_files,
        store.weaviate_migrations,
        store.weaviate_collections,
        store.sitemap_urls,
      ),
      $effect.none(),
    ];
  }
}
